export default "__VITE_ASSET__CwGOrK3D__"